import { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectLatestModelData, selectStatus, selectError } from '../../store/slices/analytics.slice';


export const useTickerLauncher = (MODELS) => {
  const dispatch = useDispatch();
  const [allTickers, setAllTickers] = useState([]);
  const [selectedModel, setSelectedModel] = useState(MODELS[0].value);
  const [dateRange, setDateRange] = useState([]);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [showSearch, setShowSearch] = useState(true);
  const [showSelectedTickers, setShowSelectedTickers] = useState(false);

  const tickers = useSelector(state => state.global.cache.tickerSearchList);
  const latestModel = useSelector(selectLatestModelData);
  const status = useSelector(selectStatus);
  const error = useSelector(selectError);

  const handleTickerSubmit = useCallback((tickers, groupName) => {
    const uniqueSymbols = new Set(allTickers.map(x => x.symbol));
    const newTickers = tickers.filter(x => !uniqueSymbols.has(x.symbol)).map(x => ({ ...x, groupName }));
    setAllTickers(prevTickers => [...prevTickers, ...newTickers]);
  }, [allTickers]);

  const handleGroupSubmit = useCallback((groupName, symbols) => {
    if (!selectedGroups.includes(groupName)) {
      const tickerObjects = symbols.map(symbol => tickers.find(ticker => ticker.symbol === symbol));
      handleTickerSubmit(tickerObjects, groupName);
      setSelectedGroups(prevGroups => [...prevGroups, groupName]);
    }
  }, [selectedGroups, tickers, handleTickerSubmit]);

  const handleRemoveTicker = useCallback((symbol) => {
    setAllTickers(prevTickers => prevTickers.filter(ticker => ticker.symbol !== symbol));
  }, []);

  const handleModelChange = useCallback((value) => {
    setSelectedModel(value);
  }, []);

  const handleDateRangeChange = useCallback((dates) => {
    setDateRange(dates);
  }, []);

  const handleRunModel = useCallback(() => {
    if (allTickers.length > 0) {
      const symbols = allTickers.map(ticker => ticker.symbol);
      const [startDate, endDate] = dateRange;
      const modelAction = MODELS.find(model => model.value === selectedModel)?.action;

      if (modelAction) {
        dispatch(modelAction({
          symbols,
          startDate: startDate?.format('YYYY-MM-DD'),
          endDate: endDate?.format('YYYY-MM-DD'),
        }));
      } else {
        console.error(`No action found for model: ${selectedModel}`);
      }
    }
  }, [allTickers, dateRange, selectedModel, dispatch, MODELS]);

  return {
    allTickers,
    selectedModel,
    dateRange,
    showGroupModal,
    selectedGroups,
    showSearch,
    showSelectedTickers,
    latestModel,
    status,
    error,
    handleTickerSubmit,
    handleGroupSubmit,
    handleRemoveTicker,
    handleModelChange,
    handleDateRangeChange,
    handleRunModel,
    setShowGroupModal,
    setShowSearch,
    setShowSelectedTickers
  };
};